import React from "react";
import { TextField, MenuItem, InputAdornment } from "@mui/material";
import { AccessTime as TimeIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const HourFormatSelect = ({ value, onChange }) => {
  const { t } = useTranslation("settings");

  const options = [
    { label: t("12h"), value: "false" },
    { label: t("24h"), value: "true" },
  ];

  return (
    <TextField
      select
      label={t("timeformat")}
      // Vi konverterar boolean till sträng för att TextField select ska trivas
      value={value.toString()}
      onChange={(e) => onChange(e.target.value === "true")}
      variant="outlined"
      size="small"
      sx={{
        minWidth: 150,
        // Vi tar bort margin här och låter föräldern styra layouten
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <TimeIcon fontSize="small" color="action" />
          </InputAdornment>
        ),
      }}
    >
      {options.map((opt) => (
        <MenuItem key={opt.value} value={opt.value}>
          {opt.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default HourFormatSelect;
